import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export default function NewWellsTable(props) {
  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell>Permit Number</TableCell>
          <TableCell>Permittee</TableCell>
          <TableCell>Well</TableCell>
          <TableCell>Allocation (MGY)</TableCell>
          <TableCell>Area</TableCell>
          <TableCell>Aggregate?</TableCell>
          <TableCell>Diam. (in.)</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.permits.length === 0 ? (
          <Typography variant='h6'>None</Typography>
        ) : (
          props.permits.map((permit, i) => (
            <TableRow key={i}>
              <TableCell>{permit.CASE_NUMBER}</TableCell>
              <TableCell>{permit.Permittee}</TableCell>
              <TableCell>{permit.WellNo}</TableCell>
              <TableCell>{permit.Allocation}</TableCell>
              <TableCell>{permit.AREA}</TableCell>
              <TableCell>{permit.NumWellsInAgg > 1 ? 'Yes' : 'No'}</TableCell>
              <TableCell>{permit.CASINGINCH}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
